/* eslint-disable id-length */
import { TimelineLite } from 'gsap'
import config from '../Config'
import { easing } from './Core'

const duration = config.messageDuration

export const messageIn = (utils) =>
  new TimelineLite({ onComplete: utils.onComplete }).fromTo(
    utils.target,
    duration,
    {
      y: config.messageSystemDistance,
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      y: 0,
      delay: utils.delay,
      ease: easing,
    },
  )

export const messageSystemIn = (utils) =>
  new TimelineLite({ onComplete: utils.onComplete }).fromTo(
    utils.target,
    duration,
    {
      y: config.messageSystemDistance,
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      y: 0,
      delay: utils.delay,
      ease: easing,
    },
  )

export const messageUserIn = (utils) =>
  new TimelineLite({ onComplete: utils.onComplete }).fromTo(
    utils.target,
    duration,
    {
      y: utils.slideIn ? config.messageUserDistance : 0,
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      y: 0,
      delay: utils.delay,
      ease: easing,
    },
  )
